<div class="actions clearfix" *ngIf="bindVariableService.allowedCategories.RESOURCE">
    <div class="resource-type col-sm-8">
        <label class="col-sm-1 control-label">{{locale.LABEL_TYPE}}: </label>
        <div class="col-sm-11">
            <select class="form-control app-select" *ngIf="resourceTypes.length > 0" [(ngModel)]="bindVariableService.selectedResourceType" (ngModelChange)="onResourceTypeChange(bindVariableService.selectedResourceType);">
                <option *ngFor="let resourceType of resourceTypes" value="{{resourceType.name}}">{{locale[resourceType.namekey]}}</option>
            </select>
            <!-- TO-DO uploading resources is not implemented -->
            <button name="wm-bindvariable-bind" class="button-primary" [hidden]="true" (click)="openUploadDialog('uploadResourcesDialog', bindVariableService.selectedResourceType)">{{locale.LABEL_UPLOAD_NEW}}</button>
        </div>
    </div>
    <div class="col-sm-4">
        <wms-search id="resource-search-box" name="resource-search-box" width="19.5em" (onSearch)="searchResource($event)"></wms-search>
    </div>
</div>
<div class="row app-row clearfix" *ngIf="bindVariableService.allowedCategories.RESOURCE">
    <div class="col-md-9 resource-list-wrapper">
        <div class="resource-list-container" *ngIf="showResourcesTab">
            <wms-tree id="resource-search-box" (nodeClick)="bindVariableService.handleTreeNodeClick($event)" [selectedNode]="bindVariableService.selectedNodeInBindDialog.resource"
            [data]="filteredResourceTree" iconType="plus" [externalSearchKey]="resourceSearchKey">
        </wms-tree>
        </div>
    </div>
    <div class="col-md-3 resource-img-wrapper">
        <div *ngIf ="bindVariableService.selectedNodeProps.resource?.path.length" [ngClass]="{'image-panel': bindVariableService.filetype !== 'folder'}">
            <div class="file-thumbnail-container" *ngIf="bindVariableService.filetype !== 'folder'">
                <div class="wm-icon64 wms wms-file-{{bindVariableService.filetype}}" *ngIf="bindVariableService.filetype !== 'image'"></div>
                <img class="app-picture " *ngIf="bindVariableService.filetype === 'image'" [src]= "baseURL + 'services/projects/' + projectService.getProjectId() + '/resources/content/web/' + bindVariableService.selectedNodeProps.resource?.path"/>
            </div>
            <div class="file-details resource-binding">
                <label>{{locale.LABEL_NAME + ': ' + bindVariableService.selectedNodeProps.resource?.name}}</label>
            </div>
        </div>
    </div>
</div>
<wms-dialog id="uploadResourcesDialog" [content]="uploadResources" name="wm-upload-resources-dialog" customClasses="upload-resource-container-dialog small wm-studio-dialog">
</wms-dialog>
<ng-template #uploadResources>
    <wms-dialog-header title="{{locale[dialogTitleKey]}}"(onClose)="closeDialogWithId('uploadResourcesDialog')"></wms-dialog-header>
    <wms-dialog-body>
        <form name="resourceUploadForm" enctype="multipart/form-data">
            <wms-message name="uploadMessage" [scopeDataset]="uploadMessage"></wms-message>
            <div>
                <label class="col-md-4">{{locale.LABEL_FILE_UPLOAD_FILE}}</label>
                 <wms-file-upload [acceptType]="mimeType" ></wms-file-upload>
            </div>
        </form>
    </wms-dialog-body>
    <wms-dialog-footer>
       <!-- TODO: disabled="{{disableDialogActions}}"  -->
      <button class="cancel-action btn app-button btn-secondary" (click)="onCancel($event)"><span class="btn-caption">{{locale.LABEL_CANCEL}}</span></button>
      <!-- TODO: disabled="{{disableDialogActions}}"  -->
      <button class="btn-primary ok-action btn app-button" (click)="onOk($event)"><span class="btn-caption">{{locale.LABEL_OK}}</span></button>
    </wms-dialog-footer>
</ng-template>
